/* ================================================================
   Custom Cable Price Calculator  v5
   Product: custom-cable  |  Variant price: $0.01
   Quantity encodes price-in-cents for order total accuracy.
   ================================================================ */

(function () {
  'use strict';

  var BRACKETS = [
    [180,  [76.68,  95.38,  132.52, 238.76, 352.74, 476.52, 505.06]],
    [204,  [76.68,  99.70,  138.42, 251.08, 383.40, 495.80, 548.96]],
    [228,  [76.68,  104.00, 144.32, 263.38, 414.08, 515.08, 592.88]],
    [252,  [79.74,  108.30, 150.24, 275.70, 444.74, 534.36, 636.82]],
    [276,  [85.88,  112.62, 156.14, 288.00, 475.42, 553.64, 680.72]],
    [300,  [92.02,  116.92, 162.06, 300.30, 506.10, 572.92, 724.64]],
    [324,  [98.16,  121.24, 167.96, 312.62, 536.76, 592.20, 768.58]],
    [348,  [104.28, 125.76, 173.86, 324.92, 567.44, 611.48, 812.46]],
    [372,  [110.42, 131.90, 179.78, 337.24, 598.10, 630.76, 856.40]],
    [396,  [116.56, 138.02, 185.68, 349.54, 628.78, 650.06, 900.32]],
    [420,  [122.68, 144.16, 191.58, 361.84, 659.46, 679.84, 944.22]],
    [444,  [128.82, 150.30, 197.50, 374.16, 690.12, 711.48, 988.16]],
    [468,  [134.96, 156.42, 203.40, 386.46, 720.80, 743.10, 1032.08]],
    [492,  [141.10, 162.56, 209.32, 398.76, 751.46, 774.72, 1091.08]],
    [516,  [147.22, 168.70, 215.22, 411.08, 782.14, 806.34, 1113.64]],
    [540,  [153.36, 174.84, 221.12, 423.38, 812.82, 837.96, 1136.20]]
  ];

  var PER_FOOT_OVER_540 = [3.06, 9.20, 9.20, 6.14, 12.26, 14.44, 14.44];

  var DIAMETER_INDICES = {
    '1/4"': 0, '5/16"': 1, '3/8"': 2, '7/16"': 3,
    '1/2"': 4, '9/16"': 5, '5/8"': 6
  };

  var END_TYPES = [
    { key: 'standard-threaded', label: 'Standard Threaded End', surcharge: 0,  diameters: 'all'       },
    { key: 'standard-button',   label: 'Standard Button End',   surcharge: 0,  diameters: 'all'       },
    { key: 'standard-eye',      label: 'Standard Eye End',      surcharge: 80, diameters: 'small-mid' },
    { key: 'fork-clevis',       label: 'Fork / Clevis End',     surcharge: 80, diameters: 'small-mid' },
    { key: 'thimble-eye',       label: 'Thimble Eye End',       surcharge: 80, diameters: 'small-mid' }
  ];

  function isDiameterAvailable(endType, diameterLabel) {
    var set = endType.diameters;
    if (set === 'all') return true;
    var small = ['1/4"', '5/16"', '3/8"'];
    var mid   = ['7/16"'];
    if (set === 'small-mid') return small.indexOf(diameterLabel) !== -1 || mid.indexOf(diameterLabel) !== -1;
    return false;
  }

  function calcBasePrice(diameterLabel, lengthIn) {
    var di = DIAMETER_INDICES[diameterLabel];
    if (di === undefined) return null;
    if (lengthIn <= BRACKETS[0][0]) return BRACKETS[0][1][di];
    for (var i = 0; i < BRACKETS.length; i++) {
      if (lengthIn <= BRACKETS[i][0]) return BRACKETS[i][1][di];
    }
    var base540  = BRACKETS[BRACKETS.length - 1][1][di];
    var ppf      = PER_FOOT_OVER_540[di];
    var extraFt  = Math.ceil((lengthIn - 540) / 12);
    return base540 + ppf * extraFt;
  }

  function calcTotalPrice(diameterLabel, end1Key, end2Key, lengthIn) {
    var base = calcBasePrice(diameterLabel, lengthIn);
    if (base === null) return null;
    var free = ['standard-threaded', 'standard-button'];
    var s1 = free.indexOf(end1Key) === -1 ? 80 : 0;
    var s2 = free.indexOf(end2Key) === -1 ? 80 : 0;
    return Math.round((base + s1 + s2) * 100) / 100;
  }

  function fmtMoney(n) { return '$' + n.toFixed(2); }

  function getWrap()         { return document.getElementById('cc-calc-wrap'); }
  function getDiamRadios()   { return [].slice.call(document.querySelectorAll('input[name="cc-diameter"]')); }
  function getInputInOnly()  { return document.getElementById('cc-inches-only'); }
  function getPriceDisplay() { return document.getElementById('cc-price-amount'); }
  function getAddBtn()       { return document.getElementById('cc-add-btn'); }
  function getMsgSuccess()   { return document.getElementById('cc-msg-success'); }
  function getMsgError()     { return document.getElementById('cc-msg-error'); }
  function getWarningBox()   { return document.getElementById('cc-nonstandard-warning'); }

  function getEnd1Options()  { return [].slice.call(document.querySelectorAll('.cc-end1-option')); }
  function getEnd2Options()  { return [].slice.call(document.querySelectorAll('.cc-end2-option')); }
  function getEnd1Radios()   { return [].slice.call(document.querySelectorAll('input[name="cc-end1"]')); }
  function getEnd2Radios()   { return [].slice.call(document.querySelectorAll('input[name="cc-end2"]')); }

  function filterEnds(diamLabel) {
    function filterGroup(optEls) {
      optEls.forEach(function (opt) {
        var key = opt.getAttribute('data-end-key');
        var endType = END_TYPES.filter(function (e) { return e.key === key; })[0];
        if (!endType) return;
        var available = isDiameterAvailable(endType, diamLabel);
        if (available) {
          opt.classList.add('cc-end-option--visible');
        } else {
          opt.classList.remove('cc-end-option--visible');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio && radio.checked) radio.checked = false;
        }
      });
      var anyChecked = optEls.some(function (o) {
        return o.classList.contains('cc-end-option--visible') &&
               o.querySelector('input[type="radio"]').checked;
      });
      if (!anyChecked) {
        var first = optEls.filter(function (o) { return o.classList.contains('cc-end-option--visible'); })[0];
        if (first) first.querySelector('input[type="radio"]').checked = true;
      }
    }
    filterGroup(getEnd1Options());
    filterGroup(getEnd2Options());
  }

  function getState() {
    var diamRadios = getDiamRadios();
    var e1Radios  = getEnd1Radios();
    var e2Radios  = getEnd2Radios();
    var iInOnly   = getInputInOnly();

    var diam = (function () { var r = diamRadios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();
    var e1   = (function () { var r = e1Radios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();
    var e2   = (function () { var r = e2Radios.filter(function (r) { return r.checked; })[0]; return r ? r.value : ''; })();

    var lengthIn = parseFloat(iInOnly ? iInOnly.value : 0) || 0;

    return { diam: diam, e1: e1, e2: e2, lengthIn: lengthIn };
  }

  function updateNonStandardWarning(s) {
    var box = getWarningBox();
    if (!box) return;
    // Only "Standard Threaded" makes a pairing "safe". If NEITHER end is
    // Standard Threaded, warn - even Standard Button + Standard Button warns.
    var hasStdThreaded = s.e1 === 'standard-threaded' || s.e2 === 'standard-threaded';
    if (hasStdThreaded || !s.e1 || !s.e2) {
      box.style.display = 'none';
      box.textContent = '';
      return;
    }
    var list = findEndLabel(s.e1) + ' and ' + findEndLabel(s.e2);
    box.textContent = 'Warning: You have selected ' + list + '. This is a non-standard and uncommon configuration. Please ensure you have selected the correct ends before adding to cart. All custom cable sales are FINAL.';
    box.style.display = 'block';
  }

  function recalc() {
    var priceDisplay = getPriceDisplay();
    var addBtn       = getAddBtn();
    if (!priceDisplay || !addBtn) return;

    var s = getState();
    updateNonStandardWarning(s);
    if (!s.diam || !s.e1 || !s.e2 || s.lengthIn <= 0) {
      priceDisplay.textContent = '--';
      addBtn.disabled = true;
      return;
    }
    var price = calcTotalPrice(s.diam, s.e1, s.e2, s.lengthIn);
    if (price === null) {
      priceDisplay.textContent = '--';
      addBtn.disabled = true;
      return;
    }
    priceDisplay.textContent = fmtMoney(price);
    addBtn.disabled = false;
  }

  window.ccRecalc = recalc;

  function buildLengthLabel() {
    return (parseFloat(getInputInOnly() ? getInputInOnly().value : 0) || 0) + ' in';
  }

  function findEndLabel(key) {
    var et = END_TYPES.filter(function (e) { return e.key === key; })[0];
    return et ? et.label : key;
  }

  var isAdding = false;

  function addToCart() {
    if (isAdding) return;
    var wrap = getWrap();
    if (!wrap) return;
    var variantId = wrap.getAttribute('data-variant-id');
    if (!variantId) return;

    var s = getState();
    if (!s.diam || !s.e1 || !s.e2 || s.lengthIn <= 0) return;
    var price = calcTotalPrice(s.diam, s.e1, s.e2, s.lengthIn);
    if (price === null) return;

    isAdding = true;

    var qtyCents = Math.round(price * 100);
    var addBtn   = getAddBtn();
    var msgOk    = getMsgSuccess();
    var msgErr   = getMsgError();

    var payload = {
      id: variantId,
      quantity: qtyCents,
      properties: {
        'Diameter':          s.diam,
        'End 1':             findEndLabel(s.e1),
        'End 2':             findEndLabel(s.e2),
        'Length':            buildLengthLabel(),
        '_calculated_price': fmtMoney(price)
      }
    };

    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding\u2026'; }
    if (msgOk)  msgOk.style.display  = 'none';
    if (msgErr) msgErr.style.display = 'none';

    var cartAddUrl = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function () {
      isAdding = false;
      var btn = getAddBtn();
      if (btn) { btn.disabled = false; btn.textContent = 'Add Another Cable to Cart'; }
      var ok = getMsgSuccess();
      if (ok) ok.style.display = 'block';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Custom Cable lines encode price as quantity (variant price
          // $0.01), so cart.item_count includes that inflated number
          // (e.g. 7668) instead of counting each cable as 1 item. Show a
          // corrected count in the header badge: each Custom Cable line
          // contributes 1, everything else counts its real quantity.
          var displayCount = 0;
          (cart.items || []).forEach(function (item) {
            var isCustomCable = item.handle === 'custom-cable' ||
              (item.properties && item.properties['_calculated_price']);
            displayCount += isCustomCable ? 1 : item.quantity;
          });
          var countWrap = document.getElementById('CartCount');
          if (countWrap) {
            var badge = countWrap.querySelector('.count.CartCount') || countWrap.querySelector('.count') || countWrap;
            badge.textContent = displayCount;
            countWrap.setAttribute('data-cart_item_count', displayCount);
            if (displayCount === 0) countWrap.classList.add('hidden');
            else countWrap.classList.remove('hidden');
          }
        })
        .catch(function () {});
    })
    .catch(function (err) {
      isAdding = false;
      var btn = getAddBtn();
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      var er = getMsgError();
      if (er) er.style.display = 'block';
      console.error('[CC] Add to cart error', err);
    });
  }

  function onCcEvent(e) {
    var t = e.target;
    if (!t) return;
    var wrap = getWrap();
    if (!wrap || !wrap.contains(t)) return;

    var id   = t.id   || '';
    var name = t.name || '';

    if (id === 'cc-inches-only') {
      recalc();
      return;
    }
    if (name === 'cc-diameter') {
      filterEnds(t.value);
      recalc();
      return;
    }
    if (name === 'cc-end1' || name === 'cc-end2') {
      recalc();
      return;
    }
    if (id === 'cc-add-btn') {
      addToCart();
    }
  }

  document.addEventListener('input',  onCcEvent, false);
  document.addEventListener('change', onCcEvent, false);
  document.addEventListener('click',  onCcEvent, false);

  var _lastStateKey = '';
  function pollState() {
    try {
      var s = getState();
      var key = s.diam + '|' + s.e1 + '|' + s.e2 + '|' + s.lengthIn;
      if (key !== _lastStateKey) {
        _lastStateKey = key;
        recalc();
      }
    } catch (e) { /* ignore */ }
  }
  setInterval(pollState, 250);

  function boot() {
    setTimeout(function () {
      var s = getState();
      if (s.diam) filterEnds(s.diam);
      recalc();
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function initCartOverride() {
    function applyCartOverride() {
      var rows = document.querySelectorAll('.cart__row, .cart-item, [data-cart-item]');
      rows.forEach(function (row) {
        if (row.classList.contains('cc-cart-processed')) return;
        var link = row.querySelector('a[href*="/products/custom-cable"]');
        if (!link) return;
        row.classList.add('cc-cart-processed');

        var qtyInput = row.querySelector('input[name^="updates"], .quantity-selector, input.cart-number, input.quantity-btn-number');
        var minusBtn = row.querySelector('.qtyminus1, .quantity-btn-minus');
        var plusBtn  = row.querySelector('.qtyplus1, .quantity-btn-plus');
        if (minusBtn) minusBtn.style.display = 'none';
        if (plusBtn)  plusBtn.style.display  = 'none';
        if (qtyInput) {
          qtyInput.style.display = 'none';
          var staticQty = document.createElement('span');
          staticQty.className = 'cc-cart-qty-display';
          staticQty.textContent = '1 custom cable';
          staticQty.style.cssText = 'font-weight:600;padding:8px 0;display:inline-block;';
          if (qtyInput.parentNode) qtyInput.parentNode.insertBefore(staticQty, qtyInput);
        }
      });
    }

    applyCartOverride();
    document.addEventListener('cart:refresh', applyCartOverride);
    document.addEventListener('ajaxCart.afterReload', applyCartOverride);
    var observer = new MutationObserver(function () { applyCartOverride(); });
    var target = document.getElementById('CartContainer') || document.getElementById('CartDrawer') || document.body;
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  initCartOverride();

})();
